import { render } from "./MiddleTitle.vue?vue&type=template&id=b71d47bc&scoped=true"
import script from "./MiddleTitle.vue?vue&type=script&lang=js"
export * from "./MiddleTitle.vue?vue&type=script&lang=js"

import "./MiddleTitle.vue?vue&type=style&index=0&id=b71d47bc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b71d47bc"

export default script